module.exports = "<app-planning-menu></app-planning-menu>\n<!-- <div class=\"clearfix\"></div> -->\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/planning.component.html
// module id = ./src/app/planning/planning.component.html
// module chunks = main